module.exports = __webpack_public_path__ + "static/media/CT_map@2x.d4ae2260.png";